! function() {
    const e = {};
    e.Nav = {
        elems: {
            womenMenu: $(".women-menu"),
            menMenu: $(".men-menu"),
            warehouseMenu: $(".warehouse-menu"),
            womenScrollableMenu: $("[data-scrollable-menu-women]"),
            menScrollableMenu: $("[data-scrollable-menu-men]"),
            logoLink: $(".header__logo__link"),
            headerMenuInner: $(".header__menu__inner-default"),
            womenMobile: $(".women-menu-mobile"),
            menMobile: $(".men-menu-mobile"),
            warehouseMobile: $(".warehouse-menu-mobile"),
            womenMenuWarehouse: $(".women-menu-warehouse"),
            menMenuWarehouse: $(".men-menu-warehouse"),
            returnBtn: $(".navlink--return")
        },
        init() {
            $("[data-gender]").mousedown((function() {
                const s = $(this).data("gender");
                e.Util.saveToStorage("gender", s)
            })), $("[data-warehouse]").click((function() {
                const s = $(this).data("warehouse");
                e.Util.saveToStorage("warehouse", s)
            })), this.loadGenderFromStorage(), this.loadWarehouseMenuFromStorage(),this.firstimeloadurl()
        },
        firstimeloadurl(){
          var url= window.location.pathname;
          var collection_url = "/collections/";
          if(url.indexOf(collection_url) != -1){
             var foundString= (url.split('/').pop()).substring(0, 1);
              if(foundString == "m"){
                var gender_val = "men";
              }
              else {
                var gender_val = "women";
              }
             e.Util.saveToStorage("gender", gender_val), e.Nav.loadGenderFromStorage()
          }
        },
        loadGenderFromStorage() {
          
            const s = e.Util.loadFromStorage("gender") || "women";
            this.updateNavVal(s), "women" === s ? (this.elems.menMenu.css("display", "none"), this.elems.womenMenu.css("display", "flex"), this.elems.menScrollableMenu.hide(), this.elems.womenScrollableMenu.show(), this.elems.menMobile.css("display", "none"), this.elems.warehouseMobile.css("display", "none")) : "men" === s ? (this.elems.menMenu.css("display", "flex"), this.elems.womenMenu.css("display", "none"), this.elems.menScrollableMenu.show(), this.elems.womenScrollableMenu.hide(), this.elems.womenMobile.css("display", "none"), this.elems.warehouseMobile.css("display", "none")) : "warehouse" === s && (this.elems.menMenu.css("display", "none"), this.elems.womenMenu.css("display", "none"), this.elems.menScrollableMenu.hide(), this.elems.womenScrollableMenu.hide(), this.elems.womenMobile.css("display", "none"), this.elems.menMobile.css("display", "none"), this.elems.menMenuWarehouse.css("display", "none"), this.elems.womenMenuWarehouse.css("display", "none"), this.elems.warehouseMenu.css("display", "flex")), "men" == s && "https://blueandcream.myshopify.com/" == window.location.href ? window.location.replace("https://blueandcream.myshopify.com/pages/men") : "warehouse" == s && "https://blueandcream.myshopify.com/" == window.location.href && window.location.replace("https://blueandcream.myshopify.com/pages/warehouse"), this.loadWarehousePage()
        },
        updateNavVal(e) {
            this.elems.headerMenuInner.css("display", "none"), this.elems.logoLink.attr("href", "https://blueandcream.myshopify.com/" + ("men" == e ? `pages/${e}` : ""))
        },
        loadWarehousePage() {
            "https://blueandcream.myshopify.com/pages/warehouse" == window.location.href && $(".navlink--warehouse").addClass("selected")
        },
        updateFromProduct() {
            const s = JSON.parse($("[data-product-json]").html());
            var n;
            if (s.tags.includes("Female") || s.tags.includes("female")) n = "women";
            else {
                if (!s.tags.includes("Male") && !s.tags.includes("male")) return;
                n = "men"
            }
            e.Util.saveToStorage("gender", n), e.Nav.loadGenderFromStorage()
        },
        loadWarehouseMenuFromStorage() {
            const s = e.Util.loadFromStorage("warehouse") || "",
                n = e.Util.loadFromStorage("gender") || "women";
            this.updateNavVal(n), "warehouse" === s ? (this.elems.menMenuWarehouse.css("display", "none"), this.elems.womenMenuWarehouse.css("display", "none"), this.elems.warehouseMenu.css("display", "flex")) : (this.elems.warehouseMenu.css("display", "none"), "men" == n ? (this.elems.menMenu.css("display", "flex"), this.elems.womenMenu.css("display", "none"), this.elems.returnBtn.attr("href", "https://blueandcream.myshopify.com/pages/men")) : (this.elems.womenMenu.css("display", "flex"), this.elems.menMenu.css("display", "none")))
        }
    }, e.Util = {
        saveToStorage(e, s) {
            "string" == typeof s ? localStorage.setItem(e, s) : localStorage.setItem(e, JSON.stringify(s))
        },
        loadFromStorage: e => localStorage.getItem(e)
    }, e.Nav.init(), $('[data-section-type="product"]').length && e.Nav.updateFromProduct(), $(".logos__marquee-container").show(), $(".logos__marquee-inner").marquee({
        duration: 15e3,
        gap: 0,
        delayBeforeStart: 0,
        direction: "left",
        duplicated: !0,
        pauseOnHover: !0,
        startVisible: !0
    })
}();

window.addEventListener("pageshow", function(event) {
   
    var historyTraversal = event.persisted ||
        (typeof window.performance != "undefined" &&
            window.performance.navigation.type === 2);
    if (historyTraversal) {
        // Handle page restore.
         //window.location.reload();
    }
});
  function frenzyQuickAddClick(this_click){
  if(this_click.closest(".frenzy_product_item").querySelector('figure').querySelector('.frenzy_variant_option.is-open')){
    this_click.closest(".frenzy_product_item").querySelector('figure').querySelector('.frenzy_variant_option')?.classList.remove('is-open');
  }else{
    document.querySelector('.frenzy_variant_option.is-open')?.classList.remove('is-open')
    this_click.closest(".frenzy_product_item").querySelector('figure').querySelector('.frenzy_variant_option')?.classList.add('is-open');
  }
}